import { Component, Input, OnInit } from '@angular/core';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { TicketStatuses } from 'app/enums/TicketStatuses.enum';
import { ApiIncomingCallService } from 'app/services/api/api-incoming-call-service';

@Component({
  standalone: false,
    selector: 'app-incoming-call',
    templateUrl: './incoming-call.component.html',
    styleUrls: ['./incoming-call.component.scss'],
})
export class IncomingCallComponent implements OnInit {
    @Input() token: string;

    private ticketStatus: number;

    public roomUrl: SafeResourceUrl;
    public iframeActive: boolean = true;
    public ticketExpired: boolean = false;

    constructor(
        private sanitizer: DomSanitizer,
        private route: ActivatedRoute,
        private apiIncomingCall: ApiIncomingCallService
    ) { }

    ngOnInit(): void {
        const token = this.route.snapshot.paramMap.get('token');

        this.apiIncomingCall.getCallReverse(token).subscribe({
            next: (result) => {
                this.ticketStatus = result.id_status;

                if (this.ticketStatus === TicketStatuses.CLOSED) {
                    this.iframeActive = false;
                    this.ticketExpired = false;
                }

                if (/^https?:\/\//i.test(result?.user_room_url ?? "")) {
                    this.roomUrl = this.sanitizer.bypassSecurityTrustResourceUrl(
                        result.user_room_url + "?logo=off&participantCount=off"
                    );
                }
            },
            error: (err) => {
                if (err.status === 500) {
                    this.iframeActive = false;
                    this.ticketExpired = true;
                }
            }
        });
    }

    terminateCall(): void {
        this.iframeActive = false;
    }
}
